import React from 'react';
import AppRoleSwitch from './AppRoleSwitch';
export default function App() {
  return <AppRoleSwitch />;
}
